import styled from 'styled-components';

const Footer = () => {
  return (
    <FooterTemplate>
      <FooterWrap>
        <FooterText>(주)네모 | 대표 이성찬 | Tel. 031-215-7065 | Fax. 031-215-8136</FooterText>
        <FooterText>경기도 용인시 기흥구 흥덕중앙로 120, U타워 2301호</FooterText>
        <FooterText>Copyright 2017. (주)네모 All rights reserved.</FooterText>
      </FooterWrap>
    </FooterTemplate>
  );
};

const FooterTemplate = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
  background: #2d4254;
`;
const FooterWrap = styled.div`
  width: 100%;
  padding: 30px 0;
  text-align: center;
`;
const FooterText = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  text-align: center;
  color: #ffffff;
  margin: auto;
`;

export default Footer;
